import { Chip } from "@mui/material";
import COLORS from "../styles/COLORS";

const StatusChip = ({ label, color, className }) => {
  const getColorStyles = (color) => {
    switch (color) {
      case "green":
        return { color: COLORS.green, backgroundColor: COLORS.lightGreen };
      case "red":
        return { color: COLORS.red, backgroundColor: COLORS.lightRed };
      case "blue":
        return { color: COLORS.blue, backgroundColor: COLORS.lightBlue };
      case "orange":
        return { color: COLORS.orange, backgroundColor: COLORS.lightOrange };
      default:
        return { color: COLORS.blue, backgroundColor: COLORS.lightBlue };
    }
  };

  return (
    <Chip
      size="small"
      label={label}
      variant="contained"
      className={className}
      sx={{ height: "16px", ...getColorStyles(color) }}
    />
  );
};

export default StatusChip;